export default {
  mark_read_dialogContent: "Please confirm.",
  mark_read_dialogTitle: "Mark all as read?",
  mark_unread_dialogContent: "Please confirm.",
  mark_unread_dialogTitle: "Mark all as unread?",
  read_notifications: "Read",
  title: "Feed",
  unread_notifications: "Unread",
}
